import { useEffect, useRef } from "react";
import "./../../styles/dashboard.css";
import { FaChevronRight } from "react-icons/fa";
import { ModernCategoryCard } from "../category/ModernCategoryGrid";
import { HashLoader } from "react-spinners";

const AccountSection = ({
  title,
  accounts,
  selectedCategory,
  setSelectedCategory,
  navigate,
  hasMoreAccounts,
  accountsLoading,
  accountsLoadingMore,
  onLoadMoreAccounts,
}) => {
  const activeAccounts = accounts?.filter((acc) => acc.product_status === "active");
  const loadMoreRef = useRef(null);

  useEffect(() => {
    if (!hasMoreAccounts || accountsLoading || !onLoadMoreAccounts) return;
    const trigger = loadMoreRef.current;
    if (!trigger) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          onLoadMoreAccounts();
        }
      },
      { root: null, rootMargin: "260px 0px", threshold: 0.1 }
    );

    observer.observe(trigger);
    return () => observer.disconnect();
  }, [hasMoreAccounts, accountsLoading, onLoadMoreAccounts, selectedCategory]);

  return (
    <section className="account-section-container">
      <div className="account-category">
        <div className="category-title-container">
          <h2 className="category-title">{title}</h2>
        </div>

        <div className="account-category-container">
          <AccountCategory
            value={"latest"}
            title={"Mới nhất"}
            selected={selectedCategory}
            onClick={() => setSelectedCategory("latest")}
          />
          <AccountCategory
            value={"pinned"}
            title={"Sản phẩm hot"}
            selected={selectedCategory}
            onClick={() => setSelectedCategory("pinned")}
          />
          <AccountCategory
            value={"under_1m"}
            title={"Tài khoản dưới 1 triệu"}
            selected={selectedCategory}
            onClick={() => setSelectedCategory("under_1m")}
          />
          <AccountCategory
            value={"under_5h"}
            title={"Tài khoản dưới 500k"}
            selected={selectedCategory}
            onClick={() => setSelectedCategory("under_5h")}
          />
        </div>

        <div className="dashboard-product-grid mgc-grid mgc-grid--game">
          {activeAccounts?.map((acc) => (
            <ModernCategoryCard key={acc._id} item={acc} type="game" />
          ))}
        </div>

        {(hasMoreAccounts || accountsLoadingMore) && (
          <div ref={loadMoreRef} className="dashboard-load-more-trigger">
            {accountsLoadingMore ? (
              <span className="dashboard-load-more-status">
                <HashLoader size={16} color="var(--hash-loader-color)" />
                <span>Đang tải thêm sản phẩm...</span>
              </span>
            ) : (
              <span className="dashboard-load-more-hint">Cuộn xuống để tải thêm</span>
            )}
          </div>
        )}

        <div className="view-all-button-wrapper">
          <div onClick={() => navigate("/category/game-account")} className="view-all-button">
            <p>Xem tất cả</p>
            <FaChevronRight className="right-view-all-icon" />
          </div>
        </div>
      </div>
    </section>
  );
};

const AccountCategory = ({ title, onClick, selected, value }) => {
  return (
    <div onClick={onClick} className={`category-button-container ${selected === value && "selected-account-category-option"}`}>
      <p>{title}</p>
    </div>
  );
};

export default AccountSection;
